import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { baseUrl } from '../../../common/constants/endpoints.constants';

@Injectable({
  providedIn: 'root',
})
export class SystemSettingsService {
  http = inject(HttpClient);
  urlPrefix = `${baseUrl}`;

  getWorkingDays() {
    return this.http.get(`${this.urlPrefix}/dashboard/working-days`);
  }

  updateWorkingDays(data: any) {
    return this.http.put(`${this.urlPrefix}/dashboard/working-days`, data);
  }
}
